import { Application, Contact, Enrolment } from '@api';
import { Epic, ofType, StateObservable } from 'redux-observable';
import { mergeMap, Observable } from 'rxjs';
import { IAction } from 'src/js/actions/IshAction';
import { IshState } from 'src/js/services/IshState';
import { addContact as addContactToCart } from '../../../../web/actions/Actions';
import { changePhase, setPayer, updateContactAddProcess, updateParentChilds } from '../../../actions/Actions';
import { Phase } from '../../../reducers/State';
import CheckoutService from '../../../services/CheckoutService';
import { addContact } from '../../contact-add/actions/Actions';
import { ADD_CONTACT_TO_SUMMARY, addContactNodeToState, getContactNodeFromBackend } from '../actions/Actions';

export const AddContactToSummary: Epic<any, IshState> = (action$: Observable<IAction>, store: StateObservable<IshState>): Observable<any> => action$.pipe(
  ofType(ADD_CONTACT_TO_SUMMARY),
  mergeMap(((action: IAction<{ contact: Contact, uncheckItems?: boolean }>) => {
    const state: IshState = store.value;

    const { type, parent, forChild } = state.checkout.contactAddProcess;
    const { contact } = action.payload;
    const payerId = parent?.id || contact.id;
    const ifParentRequired = contact.parentRequired && !parent;
    const nextPage = state.checkout.phase === Phase.ComplementEditContact ? Phase.Payment : state.checkout.page;
    const isAddParentPhase = (type === Phase.AddParent || type === Phase.ChangeParent);
    const wrongGuardianMessage = `This contact is under 18 and can not be the nominated guardian. 
    Add another contact who is over 18, or contact us to update the guardian details`;

    const allChilds = CheckoutService
      .getAllSingleChildIds(state.checkout)
      .concat(ifParentRequired ? contact.id : []);

    // Uncheck all enrolments for contact. Cases:
    // - if new contact is a parent/guardian for existing children
    // - if new contact is a payer
    const uncheckContactItems: boolean = (action.payload.uncheckItems
      || type === Phase.AddContactAsPayer
      || type === Phase.AddContactAsCompany
      || type === Phase.ChangeParent
      || type === Phase.AddParent
    );

    const result = [];

    if (!contact.id) return [changePhase(state.checkout.page)];

    // Set payer if it didn't exist
    if (!CheckoutService.hasPayer(state.checkout)) {
      result.push(setPayer(payerId));
      result.push(addContactToCart(contact));
    }

    // Force set payer from payment screen if payer age is valid or have parent
    if ((type === Phase.AddContactAsPayer || type === Phase.AddContactAsCompany || type === Phase.AddParent) && payerId) {
      result.push(setPayer(payerId));
    }

    // Update parent for existing children or reassign new parent
    if ((allChilds.length || forChild) && !contact.parentRequired && isAddParentPhase) {
      result.push(updateParentChilds(contact.id, forChild ? [forChild] : allChilds));
    }

    // Add new contact to summary and update parentRequired flag
    result.push(addContact({
      ...contact,
      parent: parent || null,
      parentRequired: contact.parentRequired,
      warning: contact.parentRequired && isAddParentPhase && wrongGuardianMessage,
    }));

    const statePart = {
      enrolments: [],
      applications: []
    };

    state.cart.courses.result.forEach((key) => {
      const cartEn = state.cart.courses.entities[key];
      if (cartEn.isAllowByApplication) {
        const app: Application = {
          contactId: contact.id,
          classId: cartEn.id,
          warnings: [],
          errors: [],
          selected: !uncheckContactItems,
          fieldHeadings: [],
        }
        statePart.applications.push(app);
      } else {
        const en: Enrolment = {
          contactId: contact.id,
          classId: cartEn.id,
          allowRemove: null,
          courseId: null,
          errors: [],
          fieldHeadings: [],
          price: { ...cartEn.price },
          relatedClassId: null,
          relatedProductId: null,
          selected: !uncheckContactItems,
          warnings: [],
        }
        statePart.enrolments.push(en);
      }
    });

    result.push(addContactNodeToState({
      contactId: contact.id,
      contactLastName: '',
      contactFirstName: '',
      contactEmail: '',
      articles: [],
      memberships: [],
      vouchers: [],
      waitingLists: [],
      ...statePart
    }));

    result.push(getContactNodeFromBackend(contact, uncheckContactItems, payerId));
    result.push(updateContactAddProcess({}, null, null));
    result.push(changePhase(nextPage));

    return result;
  }))
);
